import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import {
  TreatmentGroupMembership,
  TreatmentGroupMembershipCreatePayload
} from '@/types/treatmentGroup';
import ajax from '@/utils/ajax';

const basePath = '/api/treatment_group_memberships';

export const treatmentGroupMembershipRepository = createRepository<
  TreatmentGroupMembership,
  TreatmentGroupMembershipCreatePayload
>(basePath);

const TreatmentGroupMembershipRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async enroll(data: TreatmentGroupMembershipCreatePayload) {
      return treatmentGroupMembershipRepository.create({ host, data });
    },

    // Server-side, this ends the membership -- or soft-deletes it if it
    // hadn't started yet.
    async remove(id: string) {
      const response = await ajax.patch<never, AxiosResponse<TreatmentGroupMembership>>({
        url: `${host}${basePath}/${id}/remove/`,
        data: {} as never
      });
      return response.data;
    },

    async updateSessions(id: string, partialSessionLetters: string[]) {
      const response = await ajax.patch<
        { partial_session_letters: string[] },
        AxiosResponse<TreatmentGroupMembership>
      >({
        url: `${host}${basePath}/${id}/sessions/`,
        data: { partial_session_letters: partialSessionLetters }
      });
      return response.data;
    }
  };
};

export default TreatmentGroupMembershipRepository;
